    import axiosInstance from "../../../config/axios";

export const createPromo = async (params: any) => {
    return axiosInstance.post('/distrubutor/createBanner', params, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export const updatePromo = async (id: string, params: any) => {
    return axiosInstance.put(`/distrubutor/updateBanner/${id}`, params, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export const getPromoList = async (params: any) => {
    return axiosInstance.get('/distrubutor/getBannerList', { params });
};

export const deletePromo = async (id: string) => {
    return axiosInstance.delete(`/distrubutor/deleteBanner/${id}`);
};

// ---- Click tracking / analytics ---------------------------------------------
// One record-click endpoint per role. `platform` is "promo" | "notification" |
// "story" (defaults to "promo" on the backend) and `referenceId` is the id of
// the promo / notification / story that was clicked. The user is taken from
// the token.
export type ClickTrackPlatform = 'promo' | 'notification' | 'story';

export interface RecordClickPayload {
    platform: ClickTrackPlatform;
    referenceId: number;
}

export interface SalesRecordClickPayload extends RecordClickPayload {
    /** Customer the salesperson is working on (optional). */
    C_Number?: number | string | null;
}

/** GET /distrubutor/showPromoAnalytics/:id?platform=promo|notification|story */
export const getPromoAnalytics = async (id: string, platform?: ClickTrackPlatform) => {
    return axiosInstance.get(`/distrubutor/showPromoAnalytics/${id}`, {
        params: platform ? { platform } : undefined,
    });
};

/** POST /retailer/record-click/track */
export const trackRetailerClick = async (payload: RecordClickPayload) => {
    return axiosInstance.post(`/retailer/record-click/track`, {
        platform: payload.platform,
        referenceId: Number(payload.referenceId),
    });
};

/** POST /sales/record-click/track */
export const trackSalesClick = async (payload: SalesRecordClickPayload) => {
    const body: Record<string, any> = {
        platform: payload.platform,
        referenceId: Number(payload.referenceId),
    };
    if (payload.C_Number != null && payload.C_Number !== '') {
        body.C_Number = Number(payload.C_Number);
    }
    return axiosInstance.post(`/sales/record-click/track`, body);
};

/** @deprecated use trackRetailerClick({ platform: 'promo', referenceId }) */
export const trackRetailerPromoClick = async (payload: { promoId: number }) => {
    return trackRetailerClick({ platform: 'promo', referenceId: Number(payload?.promoId) });
};

/** @deprecated use trackSalesClick({ platform: 'promo', referenceId, C_Number }) */
export const trackSalesPromoClick = async (payload: { promoId: number; C_Number?: number | string | null }) => {
    return trackSalesClick({ platform: 'promo', referenceId: Number(payload?.promoId), C_Number: payload?.C_Number });
};

// web view

export const createWebView = async (params: any) => {
    const formData = new FormData();
    formData.append('image', params.image);
    formData.append('section', params.section);
    return axiosInstance.post('/distrubutor/webviews', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export const createWebViewForSection = async (params: any) => {
    const formData = new FormData();
    formData.append('image', params.image);
    formData.append('section', params.section);
    formData.append('productsList', JSON.stringify(params.productsList));
    return axiosInstance.post('/distrubutor/webviews', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export const getWebView = async () => {
    const response = await axiosInstance.get('/distrubutor/webviews');
    return response.data;
};

export const updateWebView = async (id: string, params: any) => {    
    const formData = new FormData();
    formData.append('image', params.image);
    return axiosInstance.put(`/distrubutor/webviews/${id}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export const getWebViewById = async (id: string) => {
    return axiosInstance.get(`/distrubutor/webviews/${id}`);
};

export const deleteWebView = async (id: string) => {
    return axiosInstance.delete(`/distrubutor/webviews/${id}`);
};

export const getProductListBySearch = async (params: any) => {
    return axiosInstance.get(`/list/productListBySearch?search=${params.search}`);
};

// Associate products with web view image
export const associateProductsWithWebView = async (webViewId: string, productIds: number[]) => {
    return axiosInstance.post(`/distrubutor/webviews/products-update/${webViewId}`, {
        productIds
    });
};

// Get products associated with a web view image
export const getProductsByWebView = async (webViewId: string) => {
    return axiosInstance.get(`/distrubutor/webviews/${webViewId}/products`);
};


// WebPriceClass CRUD routes
export const createWebPriceClass = async (params: any) => {
    return axiosInstance.post('/distrubutor/web-price-classes', params, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};
export const getAllWebPriceClasses = async (page: number, limit: number) => {
    return axiosInstance.get(`/distrubutor/web-price-classes?page=${page}&limit=${limit}`);
};
export const getWebPriceClassById = async (id: string) => {
    return axiosInstance.get(`/distrubutor/web-price-classes/${id}`);
};
export const updateWebPriceClass = async (id: string, params: any) => {
    return axiosInstance.put(`/distrubutor/web-price-classes/${id}`, params, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};
export const deleteWebPriceClass = async (id: string) => {
    return axiosInstance.delete(`/distrubutor/web-price-classes/${id}`);
};

// WebCategory CRUD routes  
export const createWebCategory = async (params: any) => {
    return axiosInstance.post('/distrubutor/web-categories', params, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};
export const getAllWebCategories = async (page: number, limit: number) => {
    return axiosInstance.get(`/distrubutor/web-categories?page=${page}&limit=${limit}`);
};
export const getWebCategoryById = async (id: string) => {
    return axiosInstance.get(`/distrubutor/web-categories/${id}`);
};
export const updateWebCategory = async (id: string, params: any) => {
    return axiosInstance.put(`/distrubutor/web-categories/${id}`, params, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};
export const deleteWebCategory = async (id: string) => {
    return axiosInstance.delete(`/distrubutor/web-categories/${id}`);
};      



export const getQuickLinks = async () => {
    const response :any = await axiosInstance.get('/distrubutor/web-quick-links');
    return response.data;
};

export const createQuickLink = async (params: any) => {
    return axiosInstance.post('/distrubutor/web-quick-links', params);
};

export const updateQuickLink = async (id: string, params: any) => {
    return axiosInstance.put(`/distrubutor/web-quick-links/${id}`, params);
};

export const deleteQuickLink = async (id: string) => {
    return axiosInstance.delete(`/distrubutor/web-quick-links/${id}`);
};  


export const createLocation = async (params: any) => {
    return axiosInstance.post('/distrubutor/web-locations', params);
};

export const getAllLocations = async () => {
    const response = await axiosInstance.get('/distrubutor/web-locations');
    return response.data;
};

export const updateLocation = async (id: string, params: any) => {
    return axiosInstance.put(`/distrubutor/web-locations/${id}`, params);
};

export const deleteLocation = async (id: string) => {
    return axiosInstance.delete(`/distrubutor/web-locations/${id}`);
};

export const createEmailMarketing = async (params: any) => {
    return axiosInstance.post('/distrubutor/email-marketing', params);
};

/** Promo bulk action: switch the selected promos on (status true) or off. */
export const bulkUpdatePromoStatus = async (ids: number[], status: boolean) => {
    return axiosInstance.put('/distrubutor/bulkUpdateBannerStatus', { ids, status });
};

/** Edit a draft email campaign. status 'draft' keeps it a draft; otherwise it is sent right away. */
export const updateEmailMarketing = async (id: number | string, params: any) => {
    return axiosInstance.put(`/distrubutor/email-marketing/${id}`, params);
};

export const getAllEmailMarketing = async () => {
    const response:any = await axiosInstance.get('/distrubutor/email-marketing');
    return response.data.data;
};

export const getEmailForCampaign = async (payload: any) => {
    const response:any = await axiosInstance.post(`/list/listOfCustomerForEmail`,payload);
    return response.data.data;
};


export const getCustomerRouteList =async () => {
    const response:any = await axiosInstance.get(`/list/customerRouteList`);
    return response.data.data;
}

export const getRetailerList = async (payload?: any) => {
    // Payload is optional: existing callers invoke this without arguments and
    // continue to hit the plain GET. When a payload (e.g. { routes, days }) is
    // provided, it is sent as query params — a GET request cannot carry a body
    // (browsers drop it), so the backend must read these from req.query.
    const response: any = await axiosInstance.get('/list/listOfRetailer', payload ? { params: payload } : undefined);
    return response.data.data;
};


export const uploadAttachment = async (params: any) => {
    const formData = new FormData();
    formData.append('attachment', params.attachment);
    return axiosInstance.post('/distrubutor/uploadAttachment', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};


export const sendDraftEmail = async (id: string) => {
    return axiosInstance.post(`/distrubutor/email-marketing/${id}/send`);
};


export const sendPromoByMail = async (promoId: string, customerNumbers: number[]) => {
    return axiosInstance.post(
        `/distrubutor/sendPromoByMail/${promoId}`,
        {
            customerNumbers
        }
    );
};

// Shares the banner into the distributor promo feed ("<D_Name> Bot") instead of
// emailing it. Returns { sentCount, skippedCount } — a SALES user is scoped to their
// own assigned customers, so a selection can be partially rejected.
export const sendPromoByChat = async (promoId: string, customerNumbers: number[]) => {
    return axiosInstance.post(
        `/distrubutor/sendPromoByChat/${promoId}`,
        {
            customerNumbers
        }
    );
};
// Landing - Showcase Videos (admin)
export const createLandingShowcaseVideo = async (params: {
    section: 'top' | 'bottom';
    title?: string;
    subtitle?: string;
    label?: string;
    productId?: string;
    sortOrder?: number | string;
    status?: boolean | string;
    video?: File | null;
    poster?: File | null;
}) => {
    const formData = new FormData();
    Object.entries(params).forEach(([key, value]) => {
        if (value === undefined || value === null) return;
        if (value instanceof File) {
            formData.append(key, value);
        } else {
            formData.append(key, String(value));
        }
    });
    return axiosInstance.post('/distrubutor/landing/showcase-videos', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};

export const getLandingShowcaseVideos = async (params: {
    section?: 'top' | 'bottom';
    page?: number;
    limit?: number;
} = {}) => {
    const response: any = await axiosInstance.get('/distrubutor/landing/showcase-videos', { params });
    return response.data?.data;
};

export const getLandingShowcaseVideoById = async (id: string | number) => {
    const response: any = await axiosInstance.get(`/distrubutor/landing/showcase-videos/${id}`);
    return response.data?.data;
};

export const updateLandingShowcaseVideo = async (
    id: string | number,
    params: {
        section?: 'top' | 'bottom';
        title?: string;
        subtitle?: string;
        label?: string;
        productId?: string;
        sortOrder?: number | string;
        status?: boolean | string;
        video?: File | null;
        poster?: File | null;
    },
) => {
    const formData = new FormData();
    Object.entries(params).forEach(([key, value]) => {
        if (value === undefined || value === null) return;
        if (value instanceof File) {
            formData.append(key, value);
        } else {
            formData.append(key, String(value));
        }
    });
    return axiosInstance.put(`/distrubutor/landing/showcase-videos/${id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};

export const deleteLandingShowcaseVideo = async (id: string | number) => {
    return axiosInstance.delete(`/distrubutor/landing/showcase-videos/${id}`);
};

// Landing - Trust Strip (admin)
export const createTrustStripItem = async (params: {
    icon: string;
    title: string;
    subtitle?: string;
    sortOrder?: number;
    status?: boolean;
    section?: 'top' | 'bottom';
}) => {
    return axiosInstance.post('/distrubutor/landing/trust-strip', params);
};

export const getTrustStripItems = async () => {
    const response: any = await axiosInstance.get('/distrubutor/landing/trust-strip');
    return response.data?.data;
};

export const getTrustStripItemById = async (id: string | number) => {
    const response: any = await axiosInstance.get(`/distrubutor/landing/trust-strip/${id}`);
    return response.data?.data;
};

export const updateTrustStripItem = async (
    id: string | number,
    params: {
        icon?: string;
        title?: string;
        subtitle?: string;
        sortOrder?: number;
        status?: boolean;
        section?: 'top' | 'bottom';
    },
) => {
    return axiosInstance.put(`/distrubutor/landing/trust-strip/${id}`, params);
};

export const deleteTrustStripItem = async (id: string | number) => {
    return axiosInstance.delete(`/distrubutor/landing/trust-strip/${id}`);
};

// Landing - Section Headers (admin)
export const getSectionHeadersAdmin = async () => {
    const response: any = await axiosInstance.get('/distrubutor/landing/section-headers');
    return response.data?.data;
};

export const createSectionHeader = async (params: {
    key: string;
    title?: string;
    subtitle?: string;
}) => {
    return axiosInstance.post('/distrubutor/landing/section-headers', params);
};

export const updateSectionHeader = async (
    id: string | number,
    params: { key?: string; title?: string; subtitle?: string },
) => {
    return axiosInstance.put(`/distrubutor/landing/section-headers/${id}`, params);
};

export const deleteSectionHeader = async (id: string | number) => {
    return axiosInstance.delete(`/distrubutor/landing/section-headers/${id}`);
};


// Advertisement pop-up (Promo & marketing > Advertisement Popup tab).
// Multipart create/update; the backend keeps at most one pop-up switched on.
export const createAdvertisementPopup = async (formData: FormData) => {
    return axiosInstance.post('/distrubutor/createAdvertisementPopup', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export const updateAdvertisementPopup = async (id: string | number, formData: FormData) => {
    return axiosInstance.put(`/distrubutor/updateAdvertisementPopup/${id}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export const getAdvertisementPopupList = async () => {
    return axiosInstance.get('/distrubutor/getAdvertisementPopupList');
};

export const toggleAdvertisementPopup = async (id: string | number) => {
    return axiosInstance.patch(`/distrubutor/advertisementPopup/${id}/toggle`);
};

export const deleteAdvertisementPopup = async (id: string | number) => {
    return axiosInstance.delete(`/distrubutor/deleteAdvertisementPopup/${id}`);
};

// Pop-up analytics: same shape as banner/story analytics plus web/mobile click
// splits. Pop-ups are retailer-only, so salesWise is always empty.
export const getAdvertisementPopupAnalytics = async (id: string | number) => {
    return axiosInstance.get(`/distrubutor/showPopupAnalytics/${id}`);
};
